/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const LeaveConversationSvg = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.69708 13.3637C1.41425 13.3637 1.16678 13.2576 0.954655 13.0455C0.742535 12.8334 0.636475 12.5859 0.636475 12.3031V1.69708C0.636475 1.41425 0.742535 1.16678 0.954655 0.954655C1.16678 0.742535 1.41425 0.636475 1.69708 0.636475H6.841V1.69708H1.69708V12.3031H6.841V13.3637H1.69708ZM10.288 10.0935L9.52786 9.33341L11.3309 7.53039H5.14403V6.46979H11.2955L9.4925 4.66676L10.2526 3.90666L13.3637 7.01776L10.288 10.0935Z"/>
  </svg>
);

export const LeaveConversationIcon = (props) => (
  <Icon component={LeaveConversationSvg} {...props} />
);
